import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

const ThemeToggle: React.FC = () => {
  const { isDark, toggleTheme } = useTheme();

  return (
    <div className="fixed top-6 right-6 z-50">
      <button
        onClick={toggleTheme}
        className={`
          relative w-14 h-8 rounded-full transition-all duration-300 ease-in-out
          ${isDark ? 'bg-blue-600' : 'bg-gray-300'}
          focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2
          shadow-lg hover:shadow-xl active:scale-95
        `}
        aria-label="Toggle theme"
        type="button"
      >
        {/* Toggle Circle */}
        <div
          className={`
            absolute top-1 left-1 w-6 h-6 bg-white rounded-full
            transition-transform duration-300 ease-in-out
            flex items-center justify-center shadow-md
            ${isDark ? 'translate-x-6' : 'translate-x-0'}
          `}
        >
          {isDark ? (
            <Moon size={14} className="text-blue-600" />
          ) : (
            <Sun size={14} className="text-yellow-500" />
          )}
        </div>
      </button>
    </div>
  );
};

export default ThemeToggle;

